var heading_default = {
  "fontElementMap": "wArqr",
  "elementSpacing": "_3Z2KS",
  "headerOne": "QJoa- _3Z2KS",
  "headerTwo": "_5BTL- _3Z2KS",
  "headerThree": "RsvCW _3Z2KS",
  "headerFour": "jItZ8 _3Z2KS",
  "headerFive": "NEIVK _3Z2KS",
  "headerSix": "ryYho _3Z2KS",
  "child": "qnKJ9"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
